define('views/components/periodic_license/periodic_license_list',['require','views/base/list_view','views/components/periodic_license/periodic_license','text!templates/components/periodic_license/periodic_license_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/periodic_license/periodic_license');

    var temp = require("text!templates/components/periodic_license/periodic_license_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

